export interface ChatSseSink {
  onMeta?: (d: { threadId?: string; model?: string; turnsLeft?: number }) => void;
  onDelta?: (d: { text?: string }) => void;
  onTool?: (d: { name?: string; args?: unknown }) => void;
  onToolResult?: (d: { name?: string; refs?: unknown[]; count?: number; levels?: string[] }) => void;
  onWidget?: (d: Record<string, unknown>) => void;
  onWriteTool?: (d: { name?: string }) => void;
  onSectionUpdated?: (d: unknown) => void;
  onSectionCreated?: (d: unknown) => void;
  onSectionsReordered?: (d: unknown) => void;
  onResourceChanged?: (d: unknown) => void;
  onBootstrapStarted?: (d: unknown) => void;
  onWebSources?: (d: unknown) => void;
  onTruncated?: () => void;
  onExhausted?: (d: { rounds?: number; writes?: Record<string, number> }) => void;
  onRetract?: () => void;
  onToolError?: (d: { name?: string; message?: string }) => void;
  onDone?: (d: { text?: string }) => void;
  onError?: (d: { message?: string }) => void;
}

type PayloadKey = Exclude<keyof ChatSseSink, 'onTruncated' | 'onRetract'>;

const PAYLOAD_EVENTS: Record<string, PayloadKey> = {
  meta: 'onMeta',
  delta: 'onDelta',
  tool: 'onTool',
  toolresult: 'onToolResult',
  widget: 'onWidget',
  write_tool: 'onWriteTool',
  section_updated: 'onSectionUpdated',
  section_created: 'onSectionCreated',
  sections_reordered: 'onSectionsReordered',
  resource_changed: 'onResourceChanged',
  bootstrap_started: 'onBootstrapStarted',
  web_sources: 'onWebSources',
  exhausted: 'onExhausted',
  tool_error: 'onToolError',
  done: 'onDone',
  error: 'onError',
};

export const CHAT_SSE_EVENTS = [...Object.keys(PAYLOAD_EVENTS), 'truncation', 'retract'];

export function dispatchChatSseEvent(event: string, data: string, sink: ChatSseSink): void {
  if (event === 'retract') return sink.onRetract?.();
  if (event === 'truncation') return sink.onTruncated?.();
  const key = PAYLOAD_EVENTS[event];
  if (!key) return;
  const handler = sink[key] as ((d: unknown) => void) | undefined;
  if (!handler) return;
  handler(JSON.parse(data));
}
